import type {
  AiBridge,
  AiContextRequest,
  AiContextResponse,
  AiHighlightCommand,
  ScenarioQuery,
} from '@modo-vivo/contracts';

/** Implementación local para pruebas; sin red ni modelos de pago. */
export class DemoAiBridge implements AiBridge {
  private highlights: AiHighlightCommand | null = null;
  private onHighlight?: (cmd: AiHighlightCommand | null) => void;

  constructor(
    private readonly query: ScenarioQuery,
    onHighlight?: (cmd: AiHighlightCommand | null) => void,
  ) {
    this.onHighlight = onHighlight;
  }

  async requestContext(req: AiContextRequest): Promise<AiContextResponse> {
    let data: Record<string, unknown> = {};
    let summary = 'Contexto simulado del escenario.';
    switch (req.scope) {
      case 'table':
        data = this.query.getTables().find((t) => String(t.number) === req.targetId.replace('table-', '')) ?? {};
        summary = `Mesa ${req.targetId}: datos ficticios para asistente externo.`;
        break;
      case 'register':
        data = this.query.getRegisterStats();
        summary = 'Estadísticas de caja simuladas.';
        break;
      case 'kitchen':
        data = { queue: this.query.getKitchenQueue() };
        summary = 'Cola de cocina simulada.';
        break;
      case 'storage':
        data = this.query.getStorage();
        summary = 'Inventario ficticio del depósito.';
        break;
      case 'employee':
        data =
          this.query.getEmployees().find((e) => e.id === req.targetId) ?? {};
        summary = `Empleado ${req.targetId}: actividad registrada en demo.`;
        break;
      default:
        data = { zone: req.targetId };
    }
    return {
      scope: req.scope,
      targetId: req.targetId,
      summary,
      data,
      simulated: true,
    };
  }

  applyHighlight(cmd: AiHighlightCommand): void {
    this.highlights = cmd;
    this.onHighlight?.(cmd);
  }

  clearHighlights(): void {
    this.highlights = null;
    this.onHighlight?.(null);
  }

  getCurrentHighlight(): AiHighlightCommand | null {
    return this.highlights;
  }
}
